import { render } from "./PackagesKids.vue?vue&type=template&id=6b60d1df&scoped=true"
import script from "./PackagesKids.vue?vue&type=script&lang=js"
export * from "./PackagesKids.vue?vue&type=script&lang=js"

import "./PackagesKids.vue?vue&type=style&index=0&id=6b60d1df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b60d1df"]])

export default __exports__